import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getDocument = async (params = {}) => {
  return await api.post("/v1/document/getDocument", params);
};

export const createDocumentTemplate = async (params = {}) => {
  return await apiFormData.post("/v1/document/createDocumentTemplate", params, {
    isFormData: true,
  });
};

export const editDocumentTemplate = async (params = {}) => {
  return await apiFormData.post("/v1/document/updateDocumentTemplate", params, {
    isFormData: true,
  });
};

export const getDocumentSignature = async (params = {}) => {
  return await api.post("/v1/document/getSignatureAndAuthorized", params);
};

export const createDocumentSignature = async (params = {}) => {
  return await apiFormData.post(
    "/v1/document/createDocumentSignature",
    params,
    {
      isFormData: true,
    }
  );
};

export const editDocumentSignature = async (params = {}) => {
  return await apiFormData.post(
    "/v1/document/updateDocumentSignature",
    params,
    {
      isFormData: true,
    }
  );
};

export const deleteDocument = async (params = {}) => {
  return await api.post("/v1/document/manageStatusBranch", params);
};
